import { Outlet } from 'react-router'
import { useMediaQuery } from 'react-responsive'
// import { routeCodes } from '@/constants/routes'
import { Container, Col, Row } from '@/components/ui'
import { Header } from './header'
// import { MobileNavigation } from './navigation'
// import { Status, TopScores } from '../profile'
// import { MobileUserBlock } from '@/components/profile/MobileUserBlock'
import { mediaBreakpoints } from '@/constants/grid'
// import { NavBar } from '../profile/generalInfo/navBar/NavBar'
// import useTesting from '@/hooks/useTesting'
// import { SurveysStatistics } from '../topManagerDashboard'
// import DepartmentStatistics from '../rectorDashboard/elements/DepartmentStatistics'
// import { EmployerCreateNavBar } from '../employer/EmployerCreateNavBar'
import s from './layout.module.scss'

const Layout = () => {
  // const [query] = useSearchParams()
  const isMobile = useMediaQuery({ maxWidth: mediaBreakpoints.md })
  // const location = useLocation().pathname
  // const isTesting = useTesting()
  // const isEmployerCreateUrl = matchPath('/my-opportunities/employer/:employerId/create-element', location)

  return (
    <>
      <Header isAuth={false} />
      <Container className={s.container} fluid>
        <Row row={20} style={!isMobile ? { flexWrap: 'nowrap' } : undefined} justify='center'>
          {/* {!isMobile ? (
            <Col className={s['nav-wrapper']}>
              <Navigation onShutterClose={() => null} />
            </Col>
          ) : (
            <Col xxs={12} xs={8} sm={0}>
              <MobileUserBlock />
            </Col>
          )} */}

          <Col className={s['main-wrapper']}>
            <Outlet />
            {/* {isMobile && (
              <div className={s['status-wrapper']}>
                {location === routeCodes.TOP_MANAGER && (
                  <>
                    <SurveysStatistics />
                  </>
                )}
                {location === routeCodes.PROFILE_NEW && <Status />}
                {location !== routeCodes.DASHBOARD &&
                  location !== routeCodes.RECTOR_STATISTICS &&
                  location !== routeCodes.RECTOR &&
                  location !== routeCodes.TOP_MANAGER &&
                  !query.has('isEdit') && <Status />}
                {location !== routeCodes.DASHBOARD && location === routeCodes.RECTOR && <DepartmentStatistics />}
                {location === routeCodes.DASHBOARD && isTesting && <TopScores />}
                {location !== routeCodes.DASHBOARD && query.has('isEdit') && <NavBar />}
              </div>
            )} */}
          </Col>

          {/* {!isMobile && (
            <Col className={s['status-wrapper']}>
              {location === routeCodes.TOP_MANAGER && (
                <>
                  <SurveysStatistics />
                </>
              )}
              {location !== routeCodes.DASHBOARD &&
                location !== routeCodes.RECTOR &&
                location !== routeCodes.RECTOR_STATISTICS &&
                location !== routeCodes.TOP_MANAGER &&
                !isEmployerCreateUrl &&
                !query.has('isEdit') && <Status />}
              {location !== routeCodes.DASHBOARD && location === routeCodes.RECTOR && <DepartmentStatistics />}
              {location === routeCodes.DASHBOARD && isTesting && <TopScores />}
              {location !== routeCodes.DASHBOARD && query.has('isEdit') && <NavBar />}
              {isEmployerCreateUrl && <EmployerCreateNavBar />}
            </Col>
          )} */}
        </Row>
      </Container>
      {/* <MobileNavigation /> */}
    </>
  )
}

export default Layout
